import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  tr: {
    // Navbar
    nav: {
      about: 'Biz',
      services: 'Servislerimiz',
      solutions: 'Çözümlerimiz',
      career: 'Kariyer',
      media: 'Medya',
      contact: 'İletişim',
    },
    // Hero
    hero: {
      title1: 'Lojistik',
      title2: 'Bizimle',
      title3: 'Kolay.',
      subtitle: 'Uçtan uca lojistik hizmetler sunuyor, işinizi kolaylaştırıyoruz.',
      servicesBtn: 'Servislerimiz',
      quoteBtn: 'Teklif Al',
    },
    // Services
    services: {
      title: 'Servislerimiz',
      subtitle: 'Deneyimli ekibimiz, sahip olduğumuz araç/ekipmanlar ve tesislerimizle kusursuz lojistik servis sunuyoruz.',
    },
    // About
    about: {
      title: 'Kısaca Movent Logistics',
      description: '2015 yılında kurulan Movent Logistics, Türkiye\'nin önde gelen lojistik firmalarından biri olarak sektörde öncü konumdadır. Modern araç filomuz, deneyimli ekibimiz ve teknolojik altyapımızla müşterilerimize en kaliteli hizmeti sunuyoruz.',
      readMore: 'Hakkımızda',
      stats: {
        shipments: 'Aylık Taşıma',
        employees: 'Çalışan',
        vehicles: 'Özmal Araç/Ekipman',
      },
    },
    // Media
    media: {
      label: 'Medya',
      title: 'Biz\'den',
      subtitle: 'Basında yer alan haberlerimizi bu bölümde inceleyebilirsiniz.',
      pressContact: 'Kurumsal iletişim birimimize ulaşmak için buraya tıklayabilirsiniz.',
    },
    // Quote Form
    quote: {
      title: 'Teklif formu',
      subtitle: 'Ekibimiz en kısa sürede talebinize yanıt verecektir.',
      name: 'Adınız',
      company: 'Şirketiniz',
      email: 'E-mail Adresiniz',
      phone: 'Telefon Numaranız',
      message: 'Mesajınız',
      submit: 'Gönder',
      success: 'Talebiniz alındı!',
      successMsg: 'Ekibimiz en kısa sürede sizinle iletişime geçecektir.',
      namePlaceholder: 'Adınızı giriniz',
      companyPlaceholder: 'Şirket adını giriniz',
      emailPlaceholder: 'ornek@email.com',
      phonePlaceholder: '0XXX XXX XX XX',
      messagePlaceholder: 'Mesajınızı buraya yazınız...',
    },
    // Footer
    footer: {
      contactTitle: 'Talep ve sorularınız için bizimle iletişime geçebilirsiniz.',
      jobsLink: 'İş başvuruları için buraya tıklayınız',
      headquarters: 'Genel Merkez',
      copyright: 'Tüm hakları saklıdır.',
    },
  },
  en: {
    // Navbar
    nav: {
      about: 'About Us',
      services: 'Our Services',
      solutions: 'Solutions',
      career: 'Career',
      media: 'Media',
      contact: 'Contact',
    },
    // Hero
    hero: {
      title1: 'Logistics',
      title2: 'Made Easy',
      title3: 'With Us.',
      subtitle: 'We provide end-to-end logistics services, simplifying your business.',
      servicesBtn: 'Our Services',
      quoteBtn: 'Get a Quote',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'With our experienced team, vehicles/equipment and facilities, we provide flawless logistics service.',
    },
    // About
    about: {
      title: 'About Movent Logistics',
      description: 'Founded in 2015, Movent Logistics is one of Turkey\'s leading logistics companies. With our modern fleet, experienced team, and technological infrastructure, we provide the highest quality service to our customers.',
      readMore: 'Read More',
      stats: {
        shipments: 'Monthly Shipments',
        employees: 'Employees',
        vehicles: 'Owned Vehicles/Equipment',
      },
    },
    // Media
    media: {
      label: 'Media',
      title: 'From Us',
      subtitle: 'You can review our press releases in this section.',
      pressContact: 'Click here to reach our corporate communications unit.',
    },
    // Quote Form
    quote: {
      title: 'Quote Form',
      subtitle: 'Our team will respond to your request as soon as possible.',
      name: 'Your Name',
      company: 'Your Company',
      email: 'Your Email',
      phone: 'Your Phone',
      message: 'Your Message',
      submit: 'Submit',
      success: 'Request received!',
      successMsg: 'Our team will contact you as soon as possible.',
      namePlaceholder: 'Enter your name',
      companyPlaceholder: 'Enter company name',
      emailPlaceholder: 'example@email.com',
      phonePlaceholder: '+90 XXX XXX XX XX',
      messagePlaceholder: 'Write your message here...',
    },
    // Footer
    footer: {
      contactTitle: 'You can contact us for your requests and questions.',
      jobsLink: 'Click here for job applications',
      headquarters: 'Headquarters',
      copyright: 'All rights reserved.',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('tr');
  const [mounted, setMounted] = useState(false);

  // Load language from localStorage on mount
  useEffect(() => {
    try {
      const savedLang = window.localStorage.getItem('movent_language');
      console.log('Loading language from localStorage:', savedLang);
      if (savedLang === 'en' || savedLang === 'tr') {
        setLanguage(savedLang);
      }
    } catch (e) {
      console.error('Error loading language:', e);
    }
    setMounted(true);
  }, []);

  // Save language to localStorage whenever it changes
  useEffect(() => {
    if (mounted) {
      try {
        console.log('Saving language to localStorage:', language);
        window.localStorage.setItem('movent_language', language);
      } catch (e) {
        console.error('Error saving language:', e);
      }
    }
  }, [language, mounted]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  const toggleLanguage = () => {
    const newLang = language === 'tr' ? 'en' : 'tr';
    console.log('Toggling language from', language, 'to', newLang);
    setLanguage(newLang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};